module.exports = __webpack_public_path__ + "img/jacket-left-sub-setIn-zipper.1f5741da.png";